// Campus photo for /colleges/colorado-college: CC BY 2.0, by Lumen Wilde, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACutler_Hall%2C_Colorado_College_Campus%2C_Colorado_Springs_(54557267860).jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/colorado-college/; credited under the photo.
const photo = {
    "slug": "colorado-college",
    "alt": "Cutler Hall on the Colorado College campus in Colorado Springs, Colorado",
    "src": "/colleges/colorado-college/campus-1600.webp",
    "srcSmall": "/colleges/colorado-college/campus-800.webp",
    "srcMid": "/colleges/colorado-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/colorado-college/og.jpg",
    "title": "Cutler Hall, Colorado College Campus, Colorado Springs (54557267860)",
    "author": "Lumen Wilde",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACutler_Hall%2C_Colorado_College_Campus%2C_Colorado_Springs_(54557267860).jpg",
    "read": "2026-10-02"
};

export default photo;
